import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Customer, FileUpload } from "@app/models/customer-registration/CustomerModel";
import { AppSettings } from "@app/common/app-setting";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import { CustomerSearchInfo } from "@app/models/customer-list/CustomerListModel";

@Injectable()
export class CustomerEndpoint extends AutharizedEndPointService {
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getOTPurl: string = 'api/AccountController/GetOtpForRegistration/';
    private readonly _toResendUrl: string = 'api/AccountController/ResendOtp/';
    private readonly _verifyOTPurl: string = 'api/AccountController/VeifyOTP/';
    private readonly _registerRetailCustomerPurl: string = 'api/AccountController/RegisterRetailCustomer';
    private readonly _registerFleetCustomerurl: string = 'api/AccountController/RegisterFleetCustomer';
    private readonly _getCustomerDetailsurl: string = 'api/MerchantDashboardReport/GetCustomerDetails/';
    private readonly _updateFleetCustomerurl: string = 'api/MerchantDashboardReport/UpdateProfile/';
    private readonly _registerPostImageDataUrl: string = 'api/MerchantDashboardReport/UploadFile/';
    private readonly _getGetCustomerListUrl: string = 'api/MerchantDashboardReport/GetCustomerDetails';
    private readonly _rejectCustomerDetailurl: string = 'api/MerchantDashboardReport/RejectDocument';
    constructor(http: HttpClient) {
        super(http, '');
        this.http1 = http;
    }

    getUrl(url: string) {
        return this._baseurl + url;
    }
    getOTP(customerinfo) {
        return this.http1.get(this.getUrl(this._getOTPurl) + customerinfo);
    }

    resendMobileOTP(mobileNumber: string) {
        return this.http1.get(this.getUrl(this._toResendUrl) + mobileNumber);
    }
    verifyOTP(mobileNumber: string, otp: string) {
        return this.http1.post(
            this.getUrl(this._verifyOTPurl) + mobileNumber
            , otp
            , {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
            }
        );
    }

    registerRetailCustomer(customerinfo: Customer) {
        return this.http1.post(this.getUrl(this._registerRetailCustomerPurl), customerinfo
            , {
                headers: new HttpHeaders().set('Content-Type', 'application/json')
            }
        );
    }
    registerFleetCustomer(customerinfo: Customer) {
        return this.http1.post(this.getUrl(this._registerFleetCustomerurl), customerinfo);
    }
    updateFleetCustomer(customerinfo: Customer) {
        return this.http1.post(this.getUrl(this._updateFleetCustomerurl) + customerinfo.CustomerId, customerinfo, this.AddAuthToken());
    }
    getCustomerDetails(id: number) {
        return this.http1.get(this.getUrl(this._getCustomerDetailsurl) + id, this.AddAuthToken());
    }
    registerPostImageData(formData: FormData) {
        return this.http1.post(this.getUrl(this._registerPostImageDataUrl), formData);
    }
    GetCustomerList(customerListModel: CustomerSearchInfo) {
        return this.http1.post(this.getUrl(this._getGetCustomerListUrl), customerListModel, this.AddAuthToken());
    }
    RejectCustomerDetail(customerFileDetails: FileUpload) {
        return this.http1.post(this.getUrl(this._rejectCustomerDetailurl), customerFileDetails, this.AddAuthToken());
    }
}


// WEBPACK FOOTER //
// ./src/app/services/customer-registration/customer-endpoint.service.ts